<template>
    <div class="list_item" @click="goDetailPage">
        <div class="img">
            <img-box
                :src="cellData.previewPicture"
                :errorImg="errorImg"
                :alt="$ft.formatAddr(cellData.address)"
            />
            <span class="property-type">{{ cellData.propertyType }}</span>
            <VerifyMask v-if="isShowMask" />
        </div>

        <div class="info">
            <div class="top">
                <div class="price">
                    <div class="left" v-if="!isShowMask" v-show="showPrice">
                        <p>
                            {{
                                $ft.formatUnitNum(
                                    cellData.showPrice,
                                    false,
                                    0,
                                    currencySymbol
                                )
                            }}
                        </p>
                        <span
                            v-if="cellData.status !== 0"
                            :class="{
                                up: cellData.status > 0,
                                down: cellData.status < 0
                            }"
                        >
                            <i
                                class="iconfont icon-arrow_04_down"
                                :class="{
                                    up: cellData.status > 0,
                                    down: cellData.status < 0
                                }"
                            ></i>
                            {{ changePriceNum }}</span
                        >
                    </div>
                    <PriceMask class="left" v-else />
                    <only-client>
                        <em
                            class="right"
                            v-if="isSoldListing"
                            v-text="getDate(cellData.listDate)"
                        ></em>
                    </only-client>
                </div>
                <p class="address">
                    <a :href="cellData.link" rel="noopener noreferrer">{{
                        !isShowMask ? $ft.formatAddr(cellData.address) : $t('addressNotDisclosed')
                    }}</a>
                </p>
                <ul>
                    <li>
                        {{
                            $t('md-listing-list.bed', {
                                count: !isShowMask ? cellData.bedrooms : '***'
                            })
                        }}
                    </li>
                    <li>
                        {{
                            $t('md-listing-list.bath', {
                                count: !isShowMask ? cellData.bathrooms : '***'
                            })
                        }}
                    </li>
                    <li>{{ !isShowMask ? cellData.sqft : '*** ' + $t('md-listing-list.sqft') }}</li>
                </ul>
            </div>
            <div class="bot" v-if="cellData.listingProvided">
                <p class="desc">
                    {{ !isShowMask ? cellData.listingProvided : '' }}
                </p>
                <site-img
                    v-if="cellData.smallLogo"
                    :src="cellData.smallLogo"
                    class="mls-logo"
                    alt="mls logo"
                />
            </div>
        </div>
    </div>
</template>

<script>
import common from '../../../_mixins/table-item/common';
export default {
    name: 'table-item',
    mixins: [common]
};
</script>

<style lang="scss">
.list-table-pc.broker{
    .list_item {
        cursor: pointer;
        border-radius: 5px;
        height: 154px;
        overflow: hidden;
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        border: solid 1px #dadada;
        .img {
            width: 220px;
            height: 100%;
            position: relative;
            border-radius: 5px 0 0 5px;
            position: relative;
            .img-box {
                height: 100%;
            }
            .property-type {
                position: absolute;
                left: 15px;
                top: 15px;
                padding: 2px 5px;
                font: 12px var(--font-bold);
                color: #fff;
                background: #348cff;
                max-width: 170px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                border-radius: 2px;
            }
        }
        .info {
            flex: 1;
            padding: 15px 20px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .top {
                .price {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    margin-bottom: 7px;
                    .left {
                        flex: 1;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        & > P {
                            font: 24px var(--font-bold);
                            color: #191919;
                            margin-right: 15px;
                        }
                        & > span {
                            font: 16px var(--font-bold);
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            &.down {
                                color: #fb4444;
                                .iconfont {
                                    display: inline-block;
                                    font-size: 12px;
                                    transform: scaleX(0.8);
                                }
                            }
                            &.up {
                                color: #29cb97;
                                .iconfont {
                                    font-size: 12px;
                                    transform: scaleX(0.8) rotate(180deg);
                                    display: inline-block;
                                }
                            }
                        }
                    }
                    em {
                        font-style: normal;
                        font: 12px var(--font-normal);
                        color: #505050;
                    }
                }
                .address {
                    a {
                        font: 14px var(--font-medium);
                        color: #505050;
                    }
                }
                & > ul {
                    margin-top: 8px;
                    display: flex;
                    flex-direction: row;
                    margin-left: -10px;
                    li:first-child:before {
                        display: none;
                    }
                    li {
                        font: 12px var(--font-normal);
                        color: #505050;
                        line-height: 15px;
                        padding: 0 10px;
                        position: relative;
                        &:before {
                            content: '';
                            width: 1px;
                            height: 8px;
                            position: absolute;
                            left: 0;
                            top: 50%;
                            background: #dadada;
                            transform: translateY(-50%);
                        }
                    }
                }
            }
            .bot {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                .desc {
                    font: 12px var(--font-normal);
                    font-style: italic;
                    color: #505050;
                    flex: 1;
                }
                img {
                    max-width: 45px;
                    max-height: 20px;
                    object-fit: cover;
                }
            }
        }
    }
}
</style>
